import React, { useState } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import StaffLogin from "../login/StaffLogin";
import {
  setWellTestDetails,
  incrementSubmittedCount,
} from "../../../configurations/redux-configurations/actions/wellTestAction";
import WellReportService from "../../../api-service/WellReportService";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch } from "react-redux";
import SessionHelper from "../../../helpers/SessionHelper";
import StorageHelper from "../../../helpers/StorageHelper";
import LoadingOverlay from "../../common/LoadingOverlay";
import { format } from "date-fns";
import {
  ERROR_SUBMITTING_WELL_TEST_FORM,
  INCOMING_TOKEN_HAS_EXPIRED,
} from "../../../configurations/MessageConstants";
import {
  EMPTY,
  PUMP_RATE_TYPE,
  STAFF_LOGGED_IN_USER,
  STAFF_SESSION_EXPIRED,
} from "../../../configurations/Constants";
import { StatusCodes } from "../../../configurations/status-codes";

function Confirmation(props) {
  const dispatch = useDispatch();
  const [showStaffLogin, setShowStaffLogin] = useState(false);
  const [formError, setFormError] = useState(false);
  const [overlayLoading, setOverlayLoading] = useState(false);
  const [isDisconnected, setIsDisconnected] = useState(false);
  const [formPayload, setFormPayload] = useState({});

  const back = (e) => {
    e.preventDefault();
    props.prevStep();
  };

  const handleRadioWithOther = (type, otherType) => {
    return type === "Other" && otherType ? otherType : type;
  };

  const handleBooleanClick = (value) => {
    if (value === "Yes") return true;
    else if (value === "No") return false;
    else return null;
  };

  const handlePumpRateType = (type, otherType) => {
    if (PUMP_RATE_TYPE[type]) return PUMP_RATE_TYPE[type];
    else if (type === "OTH" && otherType) return otherType;
    else if (type === "OTH" && !otherType) return "Other";
    else return EMPTY;
  };

  const handleIrrigTypeArray = (pivot, flood, pivotFood, other, otherType) => {
    let irrigType = [];
    if (pivot) irrigType.push(pivot);
    if (flood) irrigType.push(flood);
    if (pivotFood) irrigType.push(pivotFood);
    if (other === "OtherIrrigation" && otherType) irrigType.push(otherType);
    else if (other === "OtherIrrigation" && !otherType) irrigType.push("Other");
    return irrigType;
  };

  const handleConnectionChange = async (event) => {
    let {
      inputValues: {
        irrigationCompany,
        dateTested,
        personCompletingTest,
        license,
        wellOwnerName,
        address,
        city,
        state,
        zip,
        phone,
        wellRegistration,
        irrigatedAcres,
        fieldNickname,
        legalDescription,
        county,
        pipeWallType,
        pipeWallThickness,
        lat,
        long,
        electricityProvider,
        isElectricPowerUnit,
        nonElectric,
        otherNonElectric,
        hasHourMeter,
        doesMeterWork,
        pivotIrrigationType,
        floodIrrigationType,
        pivotFloodIrrigationType,
        otherIrrigationType,
        otherIrrigationTypeName,
        endGun,
        swingArm,
        endGunGpm,
        pumpRateType,
        otherPumpRateType,
        pumpRate,
        notes,
      },
    } = props;

    let irrigTypeArr = handleIrrigTypeArray(
      pivotIrrigationType,
      floodIrrigationType,
      pivotFloodIrrigationType,
      otherIrrigationType,
      otherIrrigationTypeName
    );
    let currentDate = new Date();
    let timestamp = currentDate.getTime();

    let payload = {
      form_id: timestamp,
      tester_info: {
        name: irrigationCompany.value,
        date_of_test: dateTested
          ? dateTested.toISOString().slice(0, 10)
          : EMPTY,
        completed_by: personCompletingTest,
        license_no: license,
      },
      well_owner: {
        owner_name: wellOwnerName,
        phone: phone,
        street: address,
        city: city,
        state: state ? state.value : EMPTY,
        pincode: zip,
      },
      well_report: {
        well_id: wellRegistration.value,
        acres_irrigated: irrigatedAcres,
        field_nickname: fieldNickname,
        legal_desc: legalDescription,
        county: county ? county.value : EMPTY,
        pipe_wall_type: pipeWallType ? pipeWallType.value : EMPTY,
        pipe_wall_thickness: pipeWallThickness,
        lat: lat,
        long: long,
        power_provider: electricityProvider ? electricityProvider.value : EMPTY,
        is_electric: handleBooleanClick(isElectricPowerUnit),
        fueled_by: handleRadioWithOther(nonElectric, otherNonElectric),
        has_hour_meter: handleBooleanClick(hasHourMeter),
        is_working: handleBooleanClick(doesMeterWork),
        irrig_type: irrigTypeArr,
        end_gun: handleBooleanClick(endGun),
        swing_arm: handleBooleanClick(swingArm),
        endgun_gpm: endGunGpm,
        pump_rate: Number(pumpRate),
        pump_rate_type: pumpRateType,
        pump_rate_type_other: otherPumpRateType,
        additional_info: notes,
      },
    };
    setFormPayload(payload);
    const condition = navigator.onLine;
    if (condition) {
      setIsDisconnected(false);
      await handleLoginConfirmation(payload);
    } else {
      setIsDisconnected(true);
      dispatch(setWellTestDetails(payload));
      props.FormSaved(true);
    }
  };

  const handleLoginConfirmation = async (payload) => {
    const current_staff = StorageHelper.getItem(STAFF_LOGGED_IN_USER);
    if (!current_staff) {
      setShowStaffLogin(true);
    } else {
      setOverlayLoading(true);
      await handleFormSubmit(payload);
    }
  };
  const CheckStaffLoggedIn = async (value) => {
    if (value) {
      setOverlayLoading(true);
      await handleFormSubmit(formPayload);
    }
  };
  const handleFormSubmit = async (payload) => {
    try {
      await WellReportService.submitWellTestForm({
        submissions: [payload],
      });
      dispatch(incrementSubmittedCount(1));
      props.FormSubmitted(true);
    } catch (error) {
      console.error(ERROR_SUBMITTING_WELL_TEST_FORM, error);
      if (!error.response) {
        setIsDisconnected(true);
        dispatch(setWellTestDetails(payload));
        props.FormSaved(true);
      } else {
        let responseData = error.response.data;
        if (
          error.response.status === StatusCodes.UNAUTHORIZED &&
          responseData.message.includes(INCOMING_TOKEN_HAS_EXPIRED)
        ) {
          StorageHelper.setItem(STAFF_SESSION_EXPIRED, true);
          SessionHelper.cleanUpStorageKeys();
          setShowStaffLogin(true);
        } else if (error.response.status === StatusCodes.BAD_REQUEST) {
          setFormError(true);
          setOverlayLoading(false);
          toast.warn(responseData.message, {
            className: "toast-container-warning",
          });
        }
      }
    }
  };

  const closeLoginModal = () => {
    setShowStaffLogin(false);
  };

  const {
    inputValues: {
      irrigationCompany,
      dateTested,
      personCompletingTest,
      license,
      wellOwnerName,
      phone,
      address,
      city,
      state,
      zip,
      wellRegistration,
      irrigatedAcres,
      fieldNickname,
      legalDescription,
      county,
      pipeWallType,
      pipeWallThickness,
      lat,
      long,
      electricityProvider,
      isElectricPowerUnit,
      nonElectric,
      otherNonElectric,
      hasHourMeter,
      doesMeterWork,
      pivotIrrigationType,
      floodIrrigationType,
      pivotFloodIrrigationType,
      otherIrrigationType,
      otherIrrigationTypeName,
      endGun,
      swingArm,
      endGunGpm,
      pumpRateType,
      otherPumpRateType,
      pumpRate,
      notes,
    },
  } = props;
  return (
    <Container className="well-test-form-confirmation">
      {formError ||
        (isDisconnected && (
          <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        ))}
      <LoadingOverlay
        showSpinner={true}
        active={overlayLoading}
        text="Submitting Form..."
      />
      <h3 className="mt-3">Confirm your Details</h3>
      <hr />
      <Row>
        <Col md={6}>
          <p>
            Irrigation Company:{" "}
            <span>{irrigationCompany ? irrigationCompany.value : EMPTY}</span>
          </p>
          <p>
            Date Tested:{" "}
            <span>{dateTested ? format(dateTested, "yyyy-MM-dd") : EMPTY}</span>
          </p>
          <p>
            Person completing the test: <span>{personCompletingTest}</span>
          </p>
          <p>
            License#: <span>{license}</span>
          </p>
        </Col>
        <Col md={6}>
          <p>
            Well Owner Name: <span>{wellOwnerName}</span>
          </p>
          <p>
            Mobile Phone Number: <span>{phone}</span>
          </p>
          <p>
            Street Adress: <span>{address}</span>
          </p>
          <p>
            City: <span>{city}</span>
          </p>
          <p>
            State: <span>{state ? state.value : EMPTY}</span>
          </p>
          <p>
            Zip Code: <span>{zip}</span>
          </p>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col md={6}>
          <p>
            Well Registration #:{" "}
            <span>{wellRegistration ? wellRegistration.value : EMPTY}</span>
          </p>
          <p>
            Acres Irrigated: <span>{irrigatedAcres}</span>
          </p>
          <p>
            Field Nickname: <span>{fieldNickname}</span>
          </p>
          <p>
            Legal Description: <span>{legalDescription}</span>
          </p>
          <p>
            County: <span>{county ? county.value : EMPTY}</span>
          </p>
          <p>
            Pipe Wall Type:{" "}
            <span>{pipeWallType ? pipeWallType.value : EMPTY}</span>
          </p>
          <p>
            Pipe Wall Thickness: <span>{pipeWallThickness}</span>
          </p>
          <p>
            Latitutde: <span>{lat}</span>
          </p>
          <p>
            Longitude: <span>{long}</span>
          </p>
        </Col>
        <Col md={6}>
          <p>
            Electricity Provider:{" "}
            <span>
              {electricityProvider ? electricityProvider.value : EMPTY}
            </span>
          </p>
          <p>
            Electric Power Unit: <span>{isElectricPowerUnit}</span>
          </p>
          <p>
            Non Electric:{" "}
            <span>{handleRadioWithOther(nonElectric, otherNonElectric)}</span>
          </p>
          <p>
            Does unit have an hour meter? <span>{hasHourMeter}</span>
          </p>
          <p>
            Does the meter work? <span>{doesMeterWork}</span>
          </p>
          <p>
            Irrigation Type:{" "}
            <span>
              {pivotIrrigationType} {floodIrrigationType}{" "}
              {pivotFloodIrrigationType}{" "}
              {otherIrrigationType === "OtherIrrigation" &&
              otherIrrigationTypeName
                ? otherIrrigationTypeName
                : otherIrrigationType === "OtherIrrigation" &&
                  !otherIrrigationTypeName
                ? "Other"
                : EMPTY}
            </span>
          </p>
          <p>
            End Gun: <span>{endGun}</span>
          </p>
          <p>
            Swing Arm: <span>{swingArm}</span>
          </p>
          <p>
            GPM of End Gun if known: <span>{endGunGpm}</span>
          </p>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col md={6}>
          <p>
            Pump Rate Type:{" "}
            <span>{handlePumpRateType(pumpRateType, otherPumpRateType)}</span>
          </p>
          <p>
            Pump Rate : <span>{pumpRate}</span>
          </p>
        </Col>

        <Col md={6}>
          <p>
            Well Test Notes: <span>{notes}</span>
          </p>
        </Col>
      </Row>
      <hr />
      <Button variant="primary" onClick={back}>
        Back
      </Button>{" "}
      <Button
        variant="primary"
        className="well-test-next-btn"
        onClick={(e) => handleConnectionChange(e)}
      >
        Confirm
      </Button>
      <StaffLogin
        showStaffLogin={showStaffLogin}
        closeLoginModal={closeLoginModal}
        CheckStaffLoggedIn={(value) => CheckStaffLoggedIn(value)}
      />
    </Container>
  );
}

export default Confirmation;
